import React from "react";
import DataTable from "react-data-table-component";
import { BsFillCaretDownFill } from "react-icons/bs";

const Table = ({ columns, data, ...restProps }) => {
  //  Internally, customStyles will deep merges your customStyles with the default styling.
  const customStyles = {
    table: {
      style: {
        backgroundColor: "transparent",
        color: "var(--black)",
      },
    },
    tableWrapper: {
      style: {
        border: "1px solid var(--line)",
        borderRadius: "10px",
        overflow: "hidden",
      },
    },
    headRow: {
      style: {
        backgroundColor: "var(--surface-2)",
        borderBottomColor: "var(--line)",
        minHeight: "40px",
      },
    },
    headCells: {
      style: {
        padding: "8px 12px",
        fontWeight: 600,
        fontSize: "12px",
        color: "var(--muted)",
      },
    },
    cells: {
      style: {
        padding: "8px 12px",
        wordBreak: "break-word",
        lineHeight: "1.4",
        fontSize: "13.5px",
      },
    },
    rows: {
      style: {
        backgroundColor: "var(--white)",
        color: "var(--black)",
        "&:not(:last-of-type)": {
          borderBottomColor: "var(--line)",
        },
      },
      highlightOnHoverStyle: {
        backgroundColor: "var(--surface-2)",
        color: "var(--black)",
        outline: "0",
        borderBottomColor: "var(--line)",
      },
    },
    noData: {
      style: {
        backgroundColor: "transparent",
        color: "var(--muted)",
      },
    },
    progress: {
      style: {
        backgroundColor: "transparent",
        color: "var(--muted)",
      },
    },
    pagination: {
      style: {
        backgroundColor: "transparent",
        color: "var(--muted)",
        borderTop: "0",
      },
      pageButtonsStyle: {
        color: "var(--muted)",
        fill: "var(--muted)",
        "&:disabled": {
          fill: "var(--line-strong)",
        },
      },
    },
  };

  return (
    <DataTable
      columns={columns}
      data={data}
      {...restProps}
      sortIcon={<BsFillCaretDownFill />}
      customStyles={customStyles}
      defaultSortFieldId={1}
      highlightOnHover
      pagination
      dense
    />
  );
};

export default Table;
